﻿Cognito.ready("legacy-entry-adapter", ["Cognito.Forms"], function ($) {
	function newOrder(form) {
		// Create the order
		var order = new Cognito.Payment.Order({ IsOpen: true });

		// Add Additional Fees
		form.get_TransactionFees().forEach(function (fee) {
			order.get_Fees().add(new Cognito.Payment.Fee({ Description: fee.get_Description() }));
		});

		return order;
	}

	Cognito.entryAdapter = {
		getEntry: function () {
			return Cognito.serialize(Cognito.Forms.model.entry);
		},
		getEntryStatus: function () {
			return this.getEntry().Entry.Status;
		},
		hasOrder: function () {
			return Cognito.Forms.model.entry.hasOwnProperty("_Order") && Cognito.Forms.model.entry.get_Order() != null;	
		},
		getOrder: function () {
			return Cognito.serialize(Cognito.Forms.model.entry.get_Order());
		},
		setEntry: function (entry, isNew) {
			ExoWeb.Observer.setValue(Cognito.Forms.model, "entry", entry);
			Sys.Application.activateElement(document.documentElement);
			return this.createResolvedDeferral();
		},
		setEntryStatus: function (status) {
			Cognito.Forms.model.entry.get_Entry().set_Status(status);
		},
		isEntry: function (entry) {
			return entry instanceof Cognito.Forms.FormEntry;
		},
		toggleEdit: function (editable) {
			if (editable)
				$(".c-entries").addClass("c-entries-edit-view");
			else
				$(".c-entries").removeClass("c-entries-edit-view");

			ExoWeb.Observer.setValue(Cognito.Forms.model, "editMode", editable);
		},
		submitEntrySuccess: function (isNew, oldStatus, data, $button) {
			$button.prop("disabled", false);
			saveEntrySuccess(isNew, oldStatus, data);
			$button.trigger("progress-finished", "successful");
		},
		submitEntryFailure: function (entryId, $button) {			
			ExoJQuery('.c-forms-form .c-forms-error .c-validation').html(Cognito.resources["entry-submission-error-heading"] + ': ' + textStatus);
			$('.c-forms-form .c-validation').addClass("c-show");
			$button.prop("disabled", false);

			if (entryId)
				controller.entryUpdateFailed(entryId);

			if (currentEntryKey)
				controller.entryUpdateFailed(currentEntryKey);

			$button.trigger("progress-finished", "failed");
		},
		getEntryProperty: function (path) {
			if (!path || typeof (path) != "string")
				return null;

			return this.evaluateEntryPropertyPath(path);
		},
		setEntryProperty: function (path, value) {
			if (!path || typeof (path) != "string")
				return null;

			return this.evaluateEntryPropertyPath(path, true, value);
		},
		entryPropertyExists: function (path) {
			if (!path || typeof (path) != "string")
				return false;

			try {
				this.evaluateEntryPropertyPath(path);
			} catch(error) {
				return false;
			}
			
			return true;
		},
		evaluateEntryPropertyPath: function(path, isSet, value) {			
			var state = Cognito.Forms.model.entry;
			var propertyPaths = path.split('.');

			for (var i = 0; i < propertyPaths.length; i++) {
				var property = propertyPaths[i];
				var useSetter = isSet && i + 1 === propertyPaths.length;

				// normalize
				property = property.split('_');
				property = property.length > 1 ? property[1] : property[0];
				property = (useSetter? "set_" : "get_") + property[0].toUpperCase() + property.substring(1);

				if (state[property] === undefined)
					throw new Error('Unable to find the property ' + property + ' in ' + (state.meta ? state.meta.type : state) + ' given the property path \'' + path + '\'.');
				else if (useSetter)
					state[property](value);
				else
					state = state[property]();
			}

			if (!isSet)
				return state;
		},
		validateEntry: function (isSavingEntry) {
			if (!isSavingEntry) {
				var entry = Cognito.Forms.model.entry;

				if(entry && entry.get_Id())
					Cognito.validate(entry);

				Cognito.Forms.refreshQuantities(true);
				return this.createResolvedDeferral();
			}
			else {
				return Cognito.Forms.refreshQuantities().then(function () {
					Cognito.Forms.updateValidation();

					if (Cognito.Forms.hasErrors()) {
						Cognito.Forms.scrollFirstErrorIntoView();
						return false;
					}

					return true;
				});
			}
		},
		saveEntry: function (success, error) {
			Cognito.Forms.saveEntry(this.getEntry(), this.hasOrder() ? this.getEntryProperty("Order.OrderAmount") : null,
				function (data) {
					success(data, data ? (data.submissionResult ? data.submissionResult.Status : null) : null);
				}, error);
		},
		saveIncompleteEntry: function (onSuccess, onFailure) {
			Cognito.Forms.saveIncompleteEntry(this.getEntry(), this.hasOrder() ? this.getEntryProperty("Order.OrderAmount") : null, onSuccess, onFailure);
		},
		createResolvedDeferral: function() {
			var d = $.Deferred();
			d.resolve();
			return d;
		},
		ensureOrderInitialized: function () {
			this.setEntryProperty("Order", newOrder(Cognito.Forms.model.currentForm));
			Cognito.Forms.rebuildOrder(Cognito.Forms.model.entry, this.getEntryProperty("Order"));
		}
	}
}); 